import { Languages } from "src/common/descriptions/types";
import { ServiceContractDebitsDescriptions } from "./types";

const DescriptionsEnUs: ServiceContractDebitsDescriptions = {
    TITLE: "Accounts Receivables",
    TABLE: {
        ACTION_BUTTON: "",
        SEARCH_PLACEHOLDER: "Search",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        CUSTOMER: "Customer",
        DESCRIPTION: "Description",
        TOTAL: "Total",
        OUTSTANDING: "Outstanding",
        STATUS: "Status",
        ACTIONS: "Actions",
        ELLAPSED: "Ellapsed",
    },
    MAIN_ACTION_TITLE: "Getting information",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    DEBIT_STATUS: {
        PENDING_PAYMENT: "Pending payment",
        PAYED: "Payed",
        ABOLISHED: "Abolished",
        EXPIRED: "Expired",
    },
    DAYS: "days",
    VIEW_CONTRACT: "View contract",
    CREATE_PAYMENT: "Create payment",
    SEND_ACCOUNT_BALANCE: "Send account balance for this charge",
    SEND_ACCOUNT_BALANCE_CONFIRMATION: "Send an account balance document for only this charge?",
}

const DescriptionsEsUs: ServiceContractDebitsDescriptions = {
    TITLE: "Contratos Activos",
    TABLE: {
        ACTION_BUTTON: "Crear Contrato",
        SEARCH_PLACEHOLDER: "Buscar Contrato",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        CUSTOMER: "Cliente",
        DESCRIPTION: "Descripción",
        TOTAL: "Total",
        OUTSTANDING: "Pendiente",
        STATUS: "Estado",
        ACTIONS: "Acciones",
        ELLAPSED: "Transcurrido",
    },
    MAIN_ACTION_TITLE: "Obteniendo información",
    MAIN_ACTION_DESCRIPTION: "Por favor espera...",
    DEBIT_STATUS: {
        PENDING_PAYMENT: "Pendiente pago",
        PAYED: "Pagada",
        ABOLISHED: "Anulada",
        EXPIRED: "Vencida",
    },
    DAYS: "días",
    VIEW_CONTRACT: "Ver contrato",
    CREATE_PAYMENT: "Registrar pago",
    SEND_ACCOUNT_BALANCE: "Enviar estado de cuenta de este cargo",
    SEND_ACCOUNT_BALANCE_CONFIRMATION: "¿Enviar un estado de cuenta únicamente para este cargo?",
}

export const serviceContractDebitsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}
